<div class="grid sm:grid-cols-4 gap-6 w-full max-w-200" data-tour-id="domyslny-status-zaplaty">
    <div class="sm:col-span-2">
        <div class="flex-auto cursor-pointer">
            <div class="leading-6 font-semibold">Domyślny status zapłaty</div>
            <div class="text-md text-secondary">Dla nowo wystawianych dokumentów automatycznie ustawiaj wybrany status zapłaty</div>
        </div>
    </div>
    <div class="sm:col-span-2">
        <mat-form-field class="w-full" [subscriptSizing]="'dynamic'">
            <mat-select [formControl]="control" matInput>
                <mat-option [value]="status.id" *ngFor="let status of statuses">
                    {{status.name}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</div>
